import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for headings. `lines` is an array of strings.
export function MaskedLines({ lines, className = "", delay = 0, trigger = "load" }) {
  const animateProps =
    trigger === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            {...animateProps}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
